import { render } from "./ExpertStatisticsAnswerDaily.vue?vue&type=template&id=1197fdd8"
import script from "./ExpertStatisticsAnswerDaily.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsAnswerDaily.vue?vue&type=script&lang=js"

import "./ExpertStatisticsAnswerDaily.vue?vue&type=style&index=0&id=1197fdd8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__